var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddColumn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.81578 0.447359H1.07894C0.760527 0.447359 0.5 0.707886 0.5 1.02632V7.9737C0.5 8.29211 0.760527 8.55264 1.07894 8.55264H2.81578C3.13419 8.55264 3.39472 8.29211 3.39472 7.9737V1.02632C3.39475 0.707886 3.13422 0.447359 2.81578 0.447359Z",
    fill: "#current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.86854 0.447361H5.1317C4.81329 0.447361 4.55276 0.707887 4.55276 1.0263V7.97367C4.55276 8.29209 4.81329 8.55261 5.1317 8.55261H6.86854C7.18695 8.55264 7.44748 8.29211 7.44748 7.9737V1.02633C7.44748 0.707887 7.18695 0.447361 6.86854 0.447361Z",
    fill: "#current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9212 0.447361H9.18432C8.86591 0.447361 8.60538 0.707887 8.60538 1.0263V7.97367C8.60538 8.29209 8.86591 8.55261 9.18432 8.55261H10.9212C11.2396 8.55261 11.5001 8.29209 11.5001 7.97367V1.0263C11.5001 0.707887 11.2396 0.447361 10.9212 0.447361Z",
    fill: "#current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddColumn);
export default __webpack_public_path__ + "static/media/AddColumn.8e386fa7256241863b8cbe150ffa0832.svg";
export { ForwardRef as ReactComponent };